import { render, staticRenderFns } from "./WithClaimSet.vue?vue&type=template&id=1a968dc8&scoped=true&"
import script from "./WithClaimSet.vue?vue&type=script&lang=js&"
export * from "./WithClaimSet.vue?vue&type=script&lang=js&"
import style0 from "./WithClaimSet.vue?vue&type=style&index=0&id=1a968dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a968dc8",
  null
  
)

export default component.exports